<template>
  <Button
    variant="primary"
    :disabled="isDisabled || loading"
    class="gap-2"
    @click="$emit('cancel')"
  >
    <b-spinner
      v-if="loading"
      small
    />
    Batalkan Order
  </Button>
</template>

<script>
import { Button } from '@/@core/components/ui'

export default {
  name: 'CancelOrderButton',
  components: {
    Button,
  },
  props: {
    status: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      cancelable: false,
      loading: false,
    }
  },
  computed: {
    isDisabled() {
      return !this.cancelable || this.status === 'Terkirim'
    },
  },
  beforeDestroy() {
    this.cancelable = false
    this.loading = false
  },
  methods: {
    setCancelable(value) {
      this.cancelable = value
    },
    setLoading(value) {
      this.loading = value
    },
  },
}
</script>
